export default __webpack_public_path__ + "static/media/reglogin-m-bg-ms.243537e2.webp";